// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
// import { connect } from "react-redux"; // Starter Custom Code
import { css } from "styled-components";

/* Starter Custom Code - Start */
import toggleFiltersOpen from "@insite/client-framework/Store/Pages/OrderHistory/Handlers/ToggleFiltersOpen";
import Accordion, { AccordionPresentationProps } from "@insite/mobius/Accordion";
import AccordionSection from "@insite/mobius/AccordionSection";
import { tableFilterProps } from "@store/Themes/common/props/table";
import getWidgetComponent from "@toolkit/Framework/Common/Utilities/getWidgetComponent";
import { connect, ResolveThunks } from "react-redux";

const OrderHistorySearchTags = getWidgetComponent("OrderHistory/OrderHistorySearchTags");

const mapDispatchToProps = {
    toggleFiltersOpen,
};
/* Starter Custom Code - End */

interface OwnProps extends WidgetProps {}

const mapStateToProps = (state: ApplicationState) => ({
    filtersOpen: state.pages.orderHistory.filtersOpen,
});

export interface OrderHistorySearchFormStyles {
    wrapper?: InjectableCss;
    headingText?: TypographyPresentationProps;
    // Starter Custom Code
    accordion?: AccordionPresentationProps;
}

export const searchFormStyles: OrderHistorySearchFormStyles = {
    wrapper: tableFilterProps.wrapper,
    accordion: tableFilterProps.accordion,
};

const styles = searchFormStyles;

/* Starter Custom Code - Start */
type Props = ResolveThunks<typeof mapDispatchToProps> & ReturnType<typeof mapStateToProps> & OwnProps;
/* Starter Custom Code - End */

const OrderHistorySearchForm: React.FunctionComponent<Props> = props => {
    return (
        /* Starter Custom Code - Start */
        <StyledWrapper {...styles.wrapper}>
            <Accordion {...styles.accordion} headingLevel={2}>
                <AccordionSection
                    title={translate("Filters")}
                    expanded={props.filtersOpen}
                    onTogglePanel={props.toggleFiltersOpen}
                >
                    <Zone contentId={props.id} zoneName="Content" />
                </AccordionSection>
            </Accordion>
            <OrderHistorySearchTags />
        </StyledWrapper>
        /* Starter Custom Code - End */
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(OrderHistorySearchForm), // Starter Custom Code
    definition: {
        group: "Order History",
        displayName: "Search Form",
        allowedContexts: ["OrderHistoryPage", "VmiOrderHistoryPage"],
    },
};

export default widgetModule;
